import consoleEvents from '../consoleEvents';
import { IS_CLIENT } from '../constants';
import { getLocale } from '../locale';
const getFormatters = () => {
    const locale = getLocale();
    const formattersKey = `hmUtilsFormatters-${locale}`;
    const formattersFromStorage = IS_CLIENT && window.sessionStorage.getItem(formattersKey);
    if (!formattersFromStorage) {
        consoleEvents.warn('You are probably using formatter function without calling formatters.init() previously. Please fix');
    }
    const cachedFormatters = formattersFromStorage || '{}';
    return JSON.parse(cachedFormatters);
};
export default getFormatters;
//# sourceMappingURL=getFormatters.js.map